interface SkillFilterProps {
  activeFilter: string;
  onFilterChange: (filter: string) => void;
}

export default function SkillFilter({ activeFilter, onFilterChange }: SkillFilterProps) {
  const filters = [
    { id: 'all', label: 'All Skills' },
    { id: 'frontend', label: 'Frontend' },
    { id: 'backend', label: 'Backend' },
    { id: 'tools', label: 'Tools & DevOps' },
    { id: 'soft', label: 'Soft Skills' }
  ];

  return (
    <div data-component-id="app/skills/components/SkillFilter.tsx:16:4" data-component-path="app/skills/components/SkillFilter.tsx" data-component-line="16" data-component-file="SkillFilter.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-wrap%20gap-3%20justify-center%22%7D" className="flex flex-wrap gap-3 justify-center">
      {filters.map((filter) => (
        <button data-component-id="app/skills/components/SkillFilter.tsx:18:8" data-component-path="app/skills/components/SkillFilter.tsx" data-component-line="18" data-component-file="SkillFilter.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
          key={filter.id}
          onClick={() => onFilterChange(filter.id)}
          className={`px-6 py-2 rounded-md font-medium text-sm transition-smooth ${
            activeFilter === filter.id
              ? 'bg-primary text-primary-foreground shadow-brand'
              : 'bg-surface text-text-secondary hover:bg-muted hover:text-foreground'
          }`}
        >
          {filter.label}
        </button>
      ))}
    </div>
  );
}